<template>
  <div class="main">
    <h2 class="conTitle">归档</h2>
    <div class="archiveItem" v-for="item in archivesData">
      <h3>{{item.archive}}&nbsp;<span>({{item.arcData.length}})</span></h3>
      <ul>
        <li v-for="i in item.arcData">
          <!--<a target="_blank" :href="i.url">{{i.caption}}</a>&emsp;<span>{{i.updatetime}}</span>-->
          <a @click="$goRoute('noteItem',{noteData:i})">{{i.caption}}</a>&emsp;<span>{{i.updatetime}}</span>
        </li>
      </ul>
    </div>


    <!--<ul class="text-center spacing" style="padding: 0">
      <li v-for="item in links"><a @click="$goRoute(item.route)">{{item.text}}</a></li>
    </ul>
    <router-view></router-view>-->
  </div>
</template>

<script>
  export default {
    name: 'archives',
    data() {
      return {
        title: '归档'
      }
    },
    computed: {
      archivesData:function () {
        let obj = {},arcCurData=this.$store.state.noteList.notes||[];
        for (let i = 0; i < arcCurData.length; i++) {
          arcCurData[i].arcTime = new Date(arcCurData[i].updatetime).getFullYear() + '年' + (new Date(arcCurData[i].updatetime).getMonth() + 1) + '月';
          if (obj[arcCurData[i].arcTime]) {
            obj[arcCurData[i].arcTime].arcData.push({
              archive: arcCurData[i].arcTime,
              caption: arcCurData[i].caption,
              updatetime: arcCurData[i].updatetime,
              url: arcCurData[i].url
            })
          } else {
            obj[arcCurData[i].arcTime] = {
              archive: arcCurData[i].arcTime,
              arcData: [
                {
                  caption: arcCurData[i].caption,
                  updatetime: arcCurData[i].updatetime,
                  url: arcCurData[i].url
                }
              ]
            }
          }
        }
        return obj
      }
    },
    mounted: function () {
      window.document.title='归档 - 小桃酥的曲奇饼';
    }
  }
</script>

<style lang="scss">
  .main{
    .conTitle{
      font-size: 32px;
      margin-bottom: 25px;
      font-weight: 300;
    }
    .archiveItem{
      margin-top: 15px;
      color: #666;
      h3{
        font-size: 18px;
        font-weight: bold;
      }
      ul{
        margin-left: 30px;
        margin-top: 15px;
        li{
          min-height: 28px;
          line-height: 28px;
          list-style: disc;
          a{
            color: #2479CC;
            cursor: pointer;
          }
          span{
            color: #666;
            font-size: 14px;
          }
        }
      }

    }
  }

</style>



// WEBPACK FOOTER //
// src/components/archives.vue